export enum EButtonColor {
	inherit = 'inherit',
	green = 'green',
	red = 'red',
}

export type TTooltipPosition = 'left' | 'right' | 'above' | 'below'
